import React, { useState } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../../Components/Common/PageBreadcrumb';
import '../../TenderOpening/components/TenderOpening.css';
import NegotiationTable from './NegotiationTable';

// This page lists Product Hydro negotiations only (ProcurementTypeHeader = 1).
// The negotiation list API has no header param; useNegotiationList narrows
// rows client-side by product tab, so lock it to the Product Hydro tab.
const PRODUCT_TAB = 'product-hydro';

const SUBTITLES = {
  buyer: 'Run price negotiations with registered suppliers cargo by cargo.',
  supplier: 'Respond to price negotiations on your offers, cargo by cargo.',
};

const NegotiationList = ({
  endpoint = '/negotiation',
  detailBasePath = '/apps-negotiation/dtl',
  listPath = '/apps-negotiation/view',
  mode = 'buyer',
  breadcrumbLabel = 'Negotiation',
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => setRefreshTrigger(prev => prev + 1);

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{ label: breadcrumbLabel, to: listPath }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-exchange-dollar-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>{breadcrumbLabel}</h4>
                  <p className='to-hero-subtitle'>
                    {SUBTITLES[mode] || SUBTITLES.buyer}
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>
            </div>

            <NegotiationTable
              endpoint={endpoint}
              detailBasePath={detailBasePath}
              mode={mode}
              productTab={PRODUCT_TAB}
              refreshTrigger={refreshTrigger}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(NegotiationList);
